module.exports = __webpack_public_path__ + "img/isologo.2c454534.png";